
    import './styles.scoped.css';
    export default {
  "alert": "awsui_alert_mx3cw_ipfn3_99",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_mx3cw_ipfn3_1",
  "root": "awsui_root_mx3cw_ipfn3_125",
  "hidden": "awsui_hidden_mx3cw_ipfn3_163",
  "with-dismiss": "awsui_with-dismiss_mx3cw_ipfn3_213",
  "with-action": "awsui_with-action_mx3cw_ipfn3_213",
  "breakpoint-default": "awsui_breakpoint-default_mx3cw_ipfn3_219",
  "header": "awsui_header_mx3cw_ipfn3_226",
  "action": "awsui_action_mx3cw_ipfn3_230",
  "action-slot": "awsui_action-slot_mx3cw_ipfn3_235",
  "action-button": "awsui_action-button_mx3cw_ipfn3_236",
  "alert-focus-wrapper": "awsui_alert-focus-wrapper_mx3cw_ipfn3_240",
  "text": "awsui_text_mx3cw_ipfn3_269",
  "icon": "awsui_icon_mx3cw_ipfn3_276",
  "message": "awsui_message_mx3cw_ipfn3_279",
  "icon-size-medium": "awsui_icon-size-medium_mx3cw_ipfn3_287",
  "icon-size-big": "awsui_icon-size-big_mx3cw_ipfn3_290",
  "icon-size-normal": "awsui_icon-size-normal_mx3cw_ipfn3_293",
  "content": "awsui_content_mx3cw_ipfn3_297",
  "dismiss": "awsui_dismiss_mx3cw_ipfn3_301",
  "dismiss-button": "awsui_dismiss-button_mx3cw_ipfn3_306",
  "type-error": "awsui_type-error_mx3cw_ipfn3_310",
  "type-warning": "awsui_type-warning_mx3cw_ipfn3_318",
  "type-success": "awsui_type-success_mx3cw_ipfn3_326",
  "type-info": "awsui_type-info_mx3cw_ipfn3_334"
};
  